module.exports = __webpack_public_path__ + "img/bg.7de06327.png";